import React from 'react';
import PropTypes from 'prop-types';

const FormCard = ({ title, children, rightAction }) => {
  return (
    <div className="card w-100 mb-3">
      <div className="card-header d-flex justify-content-between align-items-center">
        <h5 className="card-title mb-0">{title}</h5>
        {rightAction}
      </div>
      <div className="card-body">
        <div className="row g-3">
          {children}
        </div>
      </div>
    </div>
  );
};

FormCard.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  rightAction: PropTypes.node
};

export default FormCard;